<template>
  <rect width="21" height="21" rx="4" fill="#0A1B33" />
  <rect
    x="0.5"
    y="0.5"
    width="20"
    height="20"
    rx="3.5"
    stroke="white"
    stroke-opacity="0.1"
  />
  <path
    opacity="0.5"
    d="M9 7L13 10.5L9 14"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
